import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";


export class APIRequest {
    constructor(APIRequestsObject = {}) {
        this.set(APIRequestsObject);
    };


    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/api_requests/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static download_report = (queryData = {}, config = {}) => {
        return post('v1/internal/api_requests/reports/', queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }



    /**
     * @memberof APIRequest
     * @type Getter Method
     * @returns TransferRequest
     */
    get = () => {
        return {
            id: this.id,
            ledger: this.ledger,
            api_type: this.api_type,
            status: this.status,
            is_valid: this.is_valid,
            service_charge: this.service_charge,
            created_at: this.created_at,
            api_provider_charge: this.api_provider_charge,
            easebuzz_charge: this.easebuzz_charge,
            gst_amount: this.gst_amount,
            service_charge_with_gst: this.service_charge_with_gst,
            is_charged: this.is_charged,
            request_payload: this.request_payload,
            response_payload: this.response_payload,
        }
    };

    /**
     * @memberof APIRequests
     * @type Setter Method
     * @takes TransferRequest Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof APIRequest
     * @type Setter Method
     * @takes TransferRequest Params
     * @returns void
     */
    reset = () => {
        this.id = null;
        this.ledger = null;
        this.api_type = null;
        this.status = null;
        this.is_valid = null;
        this.service_charge = null;
        this.created_at = null;
        this.api_provider_charge = null;
        this.easebuzz_charge = null;
        this.gst_amount = null;
        this.service_charge_with_gst = null;
        this.is_charged = null;
        this.request_payload = null;
        this.response_payload = null;
    };
}